import DelayedLinkWithFadeout from "../components/utils/DelayedLinkWithFadeout";
import PopupHeader from "../components/PopupHeader";
import PopupFooter from "../components/PopupFooter";
// import { invoke } from "@tauri-apps/api";
import { useLocation } from "react-router-dom";
import OutlinedTitle from "../components/OutlinedTitle";
import LogoFooter from "../components/LogoFooter";
import Fade from "../components/Fade";

export default function Encerrado() {
  const atendimentoData = useLocation();
  // invoke("abre_janela", { url: atendimentoData.state.link });
  return (
    <>
      <Fade>
        <div className="grid flex-1 content-center">
          <PopupHeader textos={atendimentoData.state.textos} />

          <OutlinedTitle>
            <div className="text-8xl max-w-[25ch] font-semibold ml-8 font-tommy">
              Uma nova aba será aberta em breve com o serviço solicitado
            </div>
          </OutlinedTitle>

          <p className="text-4xl mt-4 mb-16 py-10 px-16 font-tommy">
            Após encerrar, clique no botão para concluir o atendimento
          </p>

          <DelayedLinkWithFadeout to="/">
            <div className="flex justify-center">
              <button className="bg-primary-400 font-tommy tracking-wider text-white px-4 py-2 font-semibold text-3xl rounded-lg">
                Encerrar atendimento
              </button>
            </div>
          </DelayedLinkWithFadeout>

          <PopupFooter />
        </div>
      </Fade>
      <div className="p-6">
        <LogoFooter />
      </div>
    </>
  );
}
